module.exports = __webpack_public_path__ + "media/images/emblems/Sirnach-Blazono-1b4f4038a9a0cd896c6f3a4b8ba65888.png";